// import { createMuiTheme } from "@mui/material/styles";

import { createTheme, responsiveFontSizes } from "@mui/material/styles";

import URLSearchParams from "@ungap/url-search-params";
import { setThemeAction } from "./themes.actions";
import isValidThemeFromUrl from "../services/validation/validations/is.valid.theme.from.url";
import { themeUrlParameter, themeCookieName, themes } from "./themes.config";
import {
  setPersistedItem,
  getPersistedItem,
  removePersistedItem
} from "../services/persistance/persistance.service";

const fontFamily = '"Ubuntu", sans-serif !important';

function getTheme(themePalette) {
  //   return createMuiTheme({
  let theme = createTheme({
    typography: {
      fontFamily: `${fontFamily} !important`
    },

    // props: {
    //   MuiButtonBase: {
    //     defaultProps: {
    //       disableRipple: true
    //     }
    //   }
    // },
    components: {
      MuiButtonBase: {
        root: {
          "&.MuiTab-root": {
            "&.Mui-selected": {
              borderColor: themePalette.buttonsBorderColorActive + " !important"
            },
            "&.MuiButton-root": {
              justifyContent: "start"
            }
          }
        },
        defaultProps: {
          disableRipple: true
        }
      },
      MuiTypography: {
        styleOverrides: {
          body2: {
            color: themePalette.fontPrimaryColor
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
            minHeight: "37px",
            transition: "none"
          },
          text: {
            "&:hover": {
              backgroundColor: "transparent"
            }
          }
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            "&:hover": {
              backgroundColor: "transparent",
              color: themePalette.listItemHoverColor,
              "& .MuiSvgIcon-root": {
                color: themePalette.tooltipPrimaryColor
              }
            }
          }
        }
      },
      MuiInput: {
        styleOverrides: {
          underline: {
            "&:before": {
              borderBottom: `1px solid ${themePalette.inputBeforeBorderColor}`
            },
            "&:after": {
              borderBottom: `2px solid ${themePalette.inputAfterBorderColor}`
            }

            // "&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error):before": {
            //   borderBottom: `2px solid ${themePalette.hoveredInputBeforeBorderColor}`
            // }
          },
          root: {
            fontFamily: fontFamily,
            color: themePalette.inputRootColor,
            minHeight: "30px"
          }
        }
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none" // remove the default border
              // add custom bottom border
            }
          },
          input: {
            padding: "12px  16px"
          },
          notchedOutline: {
            border: "none" // ✅ removes the border
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&.MuiOutlinedInput-input": {
              padding: "16px 0 10px 0",
              marginTop: "10px",
              "@media (max-width:600px)": {
                fontSize: "14px"
              }
            },

            "&::-webkit-input-placeholder": {
              color: themePalette.inputPlaceholderColor,
              opacity: "1"
            },
            "&.Mui-disabled": {
              WebkitTextFillColor: themePalette.inputDisabledTextColor, // Fix for Safari/Chrome
              color: themePalette.inputDisabledTextColor // Fix for other browsers
            }
          }
        }
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            paddingLeft: "0",
            // "&&$focused": {
            "& .Mui-focused": {
              color: themePalette.inputLabelFocusedColor,
              paddingTop: "40px",
              //   "&$error": {
              "& .Mui-focused.Mui-error": {
                color: themePalette.inputLabelErrorColor
              }
            }
          },
          outlined: {
            paddingLeft: "0"
          }
        }
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
            "&.Mui-disabled": {
              color: themePalette.formLabelColor
            },
            "&.MuiInputLabel-root": {
              marginTop: "11px",
              marginBottom: "60px",
              left: "10px"
            }
          }
        }
      },
      MuiCircularProgress: {
        styleOverrides: {
          styleOverrides: {
            colorPrimary: {
              color: themePalette.progressColor
            }
          }
        }
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            minHeight: "37px"
            // "& .MuiTabs-scroller": {
            //   display: "inline-block"
            // }
          },
          indicator: {
            display: "none"
          },
          flexContainer: {
            gap: "4px"
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
            minHeight: "37px",
            textTransform: "none !important",
            "&.Mui-selected": {
              color: themePalette.inputLabelFocusedColor,
              borderColor: themePalette.buttonsBorderColorActive + " !important"
            }
          },
          wrapper: {
            flexDirection: "column",
            gap: "4px",
            alignItems: "center",
            justifyContent: "center"
          }
        }
      },
      MuiGrid: {
        styleOverrides: {
          root: {
            marginTop: 0,
            marginLeft: 0,
            "&.MuiGrid-item": {
              paddingLeft: 0,
              paddingTop: 0
            }
          }
        }
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
            margin: "3px 0 0 0",
            fontSize: "0.8rem"
          }
        }
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            "&::before": {
              height: `0`
            }
          },
          rounded: {
            "&:last-child": {
              borderBottomLeftRadius: "9px",
              borderBottomRightRadius: "9px"
            }
          }
        }
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            minHeight: "50px",
            padding: "0 10px",
            "&.Mui-expanded": {
              minHeight: "50px",
              margin: "0"
            }
          },
          content: {
            justifyContent: "center",
            "& > :last-child": {
              paddingRight: `0`
            },
            "&.Mui-expanded": {
              margin: "0",
              alignItems: "center"
            }
          },
          //   expanded: {
          //     margin: `0`
          //   },
          //   expandIcon: {
          expandIconWrapper: {
            color: themePalette.expandIconColor
          }
        }
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: themePalette.radioColor
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          label: {
            paddingLeft: `0`
          },
          deleteIcon: {
            color: themePalette.stepIconColor
          }
        }
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            marginTop: "8px",
            backgroundColor: themePalette.pagePrimaryBgColor,
            border: "1px solid " + themePalette.inputBaseBorderColor,
            borderRadius: "30px",
            boxShadow:
              "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
            color: themePalette.fontPrimaryColor,
            paddingBottom: "11px",
            paddingTop: "11px", // ✅ Adds vertical space between items
            lineHeight: "1.5",
            //   "&:last-child": {
            //     marginBottom: 0
            //   },
            "&.Mui-selected": {
              color: "white",
              fontWeight: "bold",
              backgroundColor: "transarent"
            },
            "&:hover": {
              backgroundColor: themePalette.listItemHoverColor
            }
          },
          gutters: {
            whiteSpace: "break-spaces",
            fontSize: "14px"
          }
        }
      },
      MuiModal: {
        styleOverrides: {
          root: {
            zIndex: "1500", 
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)"
          }
        }
      },
      MuiDialog: {
        styleOverrides: {
          paperWidthXs: {
            "@media (min-width: 768px)": {
              maxWidth: "60%",
              width: "60%"
            }
          },
          paperWidthSm: {
            maxWidth: "800px",
            "@media (min-width: 768px)": {
              minWidth: "60%",
              scrollbarWidth: "thin",
              scrollbarColor: "#5e5e5e #161616",
              background: "linear-gradient(0deg, #000000, #000000), linear-gradient(135deg, rgba(254, 254, 254, 0.06) 0%, rgba(254, 254, 254, 0) 100%) !important",
              backgroundBlendMode: "soft-light, normal",
              "&::-webkit-scrollbar": {
                width: "8px"
              },
              "&::-webkit-scrollbar-track": {
                background: "#161616",
                borderRadius: "8px"
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#5e5e5e",
                borderRadius: "8px",
                border: "2px solid #161616"
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#7a7a7a"
              }
            }
          },
          paperWidthMd: {
            "@media (min-width: 768px)": {
              minWidth: "60%",
              scrollbarWidth: "thin",
              scrollbarColor: "#5e5e5e #161616",
              background: "linear-gradient(0deg, #000000, #000000), linear-gradient(135deg, rgba(254, 254, 254, 0.06) 0%, rgba(254, 254, 254, 0) 100%) !important",
              backgroundBlendMode: "soft-light, normal",
              "&::-webkit-scrollbar": {
                width: "8px"
              },
              "&::-webkit-scrollbar-track": {
                background: "#161616",
                borderRadius: "8px"
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#5e5e5e",
                borderRadius: "8px",
                border: "2px solid #161616"
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#7a7a7a"
              }
            }
          },
          paperWidthLg: {
            "@media (min-width: 768px)": {
              minWidth: "60%",
              scrollbarWidth: "thin",
              scrollbarColor: "#5e5e5e #161616",
              background: "linear-gradient(0deg, #000000, #000000), linear-gradient(135deg, rgba(254, 254, 254, 0.06) 0%, rgba(254, 254, 254, 0) 100%) !important",
              backgroundBlendMode: "soft-light, normal",
              "&::-webkit-scrollbar": {
                width: "8px"
              },
              "&::-webkit-scrollbar-track": {
                background: "#161616",
                borderRadius: "8px"
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#5e5e5e",
                borderRadius: "8px",
                border: "2px solid #161616"
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#7a7a7a"
              }
            }
          }
        }
      },
      MuiTable: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily
          }
        }
      },
      MuiTableCell: {
        styleOverrides: {
          body: {
            color: themePalette.cellColor,
            textAlign: "left",
            verticalAlign: "baseline",
            fontSize: "16px",
            "&:first-child": {
              paddingLeft: "20px"
            },
            "&:last-child": {
              paddingRight: "0"
            }
          }
        }
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            // paddingRight: "52px",
            display: "flex",
            border: "1px solid " + themePalette.inputBaseBorderColor,
            borderRadius: "9999px",
            color: themePalette.fontPrimaryColor,
            paddingLeft: "16px !important"
          },
          outlined: {
            paddingBottom: "10px",
            paddingTop: "30px",
            paddingLeft: "0"
          },
          selectMenu: {
            "& > div": {
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "& > span": {
              overflow: "hidden",
              textOverflow: "ellipsis"
            }
          }
        }
      },
      MuiList: {
        styleOverrides: {
          padding: {
            paddingTop: "0",
            paddingBottom: "0"
          }
        }
      },
      MuiListItem: {
        styleOverrides: {
          button: {
            "&:hover": {
              backgroundColor: themePalette.listItemHoverColor
            }
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: themePalette.pagePrimaryBgColor
          }
        }
      },
      MuiStepper: {
        styleOverrides: {
          root: {
            backgroundColor: "inherit",
            padding: "24px 0",
            "@media (max-width: 425px)": {
              flexWrap: "wrap"
            }
          }
        }
      },
      MuiStep: {
        styleOverrides: {
          root: {
            "@media (max-width: 425px)": {
              "&:nth-child(4n + 4)": {
                paddingLeft: "0"
              },
              "&:nth-child(4n + 4) > div": {
                display: "none"
              }
            }
          },
          alternativeLabel: {
            "@media (max-width: 425px)": {
              flex: "1 1 33%",
              marginBottom: "15px"
            }
          }
        }
      },
      MuiStepIcon: {
        styleOverrides: {
          root: {
            color: themePalette.stepIconBgColor,
            "&.Mui-active": {
              "& $text": {
                fill: "#ebebef"
              }
            }
          },
          text: {
            fill: themePalette.stepIconColor,
            fontWeight: "bold"
          }
          //   active: {
          //     "& $text": {
          //       fill: themePalette.stepIconBgColor
          //     }
          //   }
        }
      },
      MuiStepLabel: {
        styleOverrides: {
          iconContainer: {
            paddingRight: "0"
          },
          label: {
            color: themePalette.inputRootColor,
            "&$active": {
              color: themePalette.inputRootColor
            },
            "&$completed": {
              color: themePalette.inputRootColor
            },
            "@media (max-width: 425px)": {
              fontSize: "12px",
              marginTop: "7px!important"
            }
          }
        }
      },
      MuiStepConnector: {
        styleOverrides: {
          line: {
            borderColor: themePalette.stepLineColor
          }
        }
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            color: themePalette.fontPrimaryColor,
            backgroundColor: themePalette.pagePrimaryBgColor,
            fontSize: "inherit",
            whiteSpace: "pre-line"
          }
        }
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: themePalette.radioColor
          },
          colorPrimary: {
            color: themePalette.inputLabelFocusedColor,
            // "&$checked": {
            "&.Mui-checked": {
              color: themePalette.inputLabelActiveColor
            }
          }
        }
      },
      MuiSnackbar: {
        root: {
          top: "5px",
          left: "50%",
          right: "auto"
        }
      }
    },
    palette: {
      primary: themePalette.primary,
      secondary: themePalette.secondary,
      grey: themePalette.grey,
      error: themePalette.error,
      mode: "dark"
    }
  });
  theme = responsiveFontSizes(theme);

  return theme;
}

const getThemeFromUrl = (search) => {
  const searchParams = new URLSearchParams(search);

  return isValidThemeFromUrl(search) ? searchParams.get(themeUrlParameter) : null;
};

const themeSettings = {
  getTheme: () => {
    return getPersistedItem(themeCookieName);
  },
  removeTheme: () => {
    removePersistedItem(themeCookieName);
  },
  setTheme: (theme) => {
    setPersistedItem(themeCookieName, theme);
  }
};

function getThemeFromCookie() {
  const { dark, light } = themes;
  //   const theme = themeSettings.getTheme();
  //   const isDarkTheme = theme && theme === dark.cookieValue;

  //   return isDarkTheme ? dark.name : light.name;
  return dark.name;
}

function setThemeCookie(theme) {
  const { dark, light } = themes;

  if (theme === light.name) {
    themeSettings.removeTheme();
  }

  if (theme === dark.name) {
    themeSettings.setTheme(dark.cookieValue);
  }
}

const setTheme = (theme) => (dispatch) => {
  dispatch(setThemeAction(theme));
  //   setThemeCookie(theme);

  document.getElementById("body").className = "";
  document.getElementById("body").className = "dark-theme"; // `${theme}-theme`;
};

export { getThemeFromCookie, getTheme, getThemeFromUrl, setTheme };
